import React, { useState, useRef } from "react";
import SEO from "../components/SEO";
import emailjs from '@emailjs/browser';
import { toast } from "react-hot-toast";
import "./css/Contact.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FaqAccordion from '../components/FAQAccordion';

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const [touched, setTouched] = useState({
    name: false,
    email: false,
    message: false,
  });

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const allValid =
    name.trim().length >= 3 &&
    isValidEmail(email) &&
    message.trim().length >= 100;

  const getBorderClass = (value, validCondition, isTouched) => {
    if (!isTouched) return "";
    return validCondition ? "valid" : "invalid";
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!allValid) return;

    setLoading(true);

    // Only Send Admin Notification
    emailjs.sendForm(
      'service_bamhwup',
      'template_5pm5lx2', // Admin template ID
      form.current,
      'l4cUAd3YCvJkPqnj_'
    )
    .then(() => {
      toast.success("Message Sent Successfully");
      e.target.reset();
      setTimeout(() => window.location.reload(), 1000);
    })
    .catch((error) => {
      console.error("Email failed:", error.text);
      toast.error("Failed to send message, please try again.");
      setLoading(false);
    });
  };

  return (
    <>
      <SEO
        title="Contact Us - Joujo Safaris | Plan Your Next Adventure"
        description="Contact Joujo Safaris to plan your dream safari. Whether you're seeking luxury lodges, Big Five adventures, or cultural encounters, we’re here to assist with bookings and inquiries."
        url="https://joujosafaris.com/contact"
        image="https://www.joujosafaris.com/static/media/logo.87843514b1c67d56f320.png"
        keywords="contact us, Joujo Safaris, Kenya safari, Tanzania safari, Big Five tours, luxury lodges, African safari travel agency"
      />

      <Navbar />
      <div className="contact-page container">
        <div className="career-main-title">
          <h4 className="text-color">REACH OUT TO US</h4>
          <h5>Contact Us</h5>
          <p className="subtitle">
            Have questions about safaris, bookings, or custom trips? Fill in the form below or explore our help section.
          </p>
        </div>

        <div className="contact-sect">
          <div className="contact-container">
            <div className="contact-card">
              <h2>Contact Form</h2>
              <form ref={form} onSubmit={sendEmail}>
                {/* Name */}
                <div className="form-group">
                  <label>Your Name</label>
                  <input
                    type="text"
                    name="name"
                    className={`input_1 ${getBorderClass(name, name.trim().length >= 3, touched.name)}`}
                    onChange={(e) => {
                      setName(e.target.value);
                      setTouched((t) => ({ ...t, name: true }));
                    }}
                    required
                    placeholder="Enter your full name"
                  />
                  {touched.name && (
                    <p className={`contact-message ${getBorderClass(name, name.trim().length >= 3, touched.name)}`}>
                      {name.trim().length >= 3 ? "Looks good!" : "Name should be at least 3 characters."}
                    </p>
                  )}
                </div>

                {/* Email */}
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="reply_to"
                    className={`input_1 ${getBorderClass(email, isValidEmail(email), touched.email)}`}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setTouched((t) => ({ ...t, email: true }));
                    }}
                    required
                    placeholder="your@email.com"
                  />
                  {touched.email && (
                    <p className={`contact-message ${getBorderClass(email, isValidEmail(email), touched.email)}`}>
                      {isValidEmail(email) ? "Perfect!" : "Enter a valid email address."}
                    </p>
                  )}
                </div>

                {/* Message Body */}
                <div className="form-group">
                  <label>Message</label>
                  <textarea
                    name="body"
                    className={`input_1 ${getBorderClass(message, message.trim().length >= 100, touched.message)}`}
                    onChange={(e) => {
                      setBody(e.target.value);
                      setTouched((t) => ({ ...t, message: true }));
                    }}
                    rows="4"
                    placeholder="Tell us about your travel plans, safari interest, or inquiry..."
                    required
                  ></textarea>
                  {touched.message && (
                    <p className={`contact-message ${getBorderClass(message, message.trim().length >= 100, touched.message)}`}>
                      {message.trim().length >= 100
                        ? "Great details, thank you!"
                        : "Please provide at least 100 characters for clarity."}
                    </p>
                  )}
                </div>

                {/* Hidden fixed sender */}
                <input type="hidden" name="from_email" value="no-reply@joujosafaris.com" />

                {/* Submit */}
                <button type="submit" className="submit-btn" disabled={!allValid || loading}>
                  {loading ? <span className="dots-loader"></span> : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Valuable Links */}
        <section className="links-section">
          <h2>Useful Resources</h2>
          <div className="links-grid">
            <div className="link-card">
              <h3>Our Blog</h3>
              <p>Read travel tips, safari insights, and adventure guides written by our experts.</p>
              <a href="/blog">Visit Blog</a>
            </div>
            <div className="link-card">
              <h3>Help Center</h3>
              <p>Find answers to common safari booking questions and travel support info.</p>
              <a href="/help">Go to Help Center</a>
            </div>
            <div className="link-card">
              <h3>Destinations</h3>
              <p>Explore top destinations including Kenya, Tanzania, Zanzibar, and more.</p>
              <a href="/trips">View Trips</a>
            </div>
          </div>
        </section>

        <FaqAccordion />
      </div>
      <Footer />
    </>
  );
}
